/**
 * @flow
 * @relayHash fcb74de939353b8f40b7875065b5669c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddMachineTypeInput = {|
  name: string
|};
export type AddMachineTypeMutationVariables = {|
  input: AddMachineTypeInput
|};
export type AddMachineTypeMutationResponse = {|
  +addMachineType: {|
    +machineTypeEdge: {|
      +cursor: string,
      +node: {|
        +id: string,
        +name: string,
      |},
    |}
  |}
|};
export type AddMachineTypeMutation = {|
  variables: AddMachineTypeMutationVariables,
  response: AddMachineTypeMutationResponse,
|};
*/


/*
mutation AddMachineTypeMutation(
  $input: AddMachineTypeInput!
) {
  addMachineType(input: $input) {
    machineTypeEdge {
      cursor
      node {
        id
        name
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddMachineTypeInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "addMachineType",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddMachineTypePayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "machineTypeEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "MachineTypeEdge",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "cursor",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "MachineType",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AddMachineTypeMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AddMachineTypeMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "AddMachineTypeMutation",
    "id": null,
    "text": "mutation AddMachineTypeMutation(\n  $input: AddMachineTypeInput!\n) {\n  addMachineType(input: $input) {\n    machineTypeEdge {\n      cursor\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'edc666935dec24a99482d31aa877d33e';
module.exports = node;
